import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { CardComponent } from '../card.component';

@Component({
    selector: 'lib-error-card',
    standalone: true,
    imports: [CommonModule, CardComponent],
    templateUrl: './error-card.component.html',
    styleUrl: './error-card.component.css'
})
export class ErrorCardComponent implements OnChanges {
    /* eslint-disable */
    @Input() errors: any = null; //Pass the error object
    @Input() defaultMessage: string = 'There was an error. Please try again later.';
    @Input() marginTop: boolean = false;
    @Input() marginBottom: boolean = true;
    @Input() marginHorizontal: boolean = false;

    errorType: 'http-error' | 'api-response' | 'string' | 'none' = 'string';

    ngOnChanges(changes: SimpleChanges): void {
        const errorChanges = changes['errors'];
        // console.log(errorChanges);
        if (errorChanges) {
            const currentValue = errorChanges?.currentValue;
            this.setErrorType(currentValue);
        }
    }

    setErrorType(value: any) {
        if (value?.message) {
            this.errorType = 'http-error';
        } else if (value && typeof value !== 'string' && Object.keys(value).length > 0) {
            this.errorType = 'api-response';
        } else if (typeof value === 'string') {
            this.errorType = 'string';
        } else {
            this.errorType = 'none';
        }
    }

    joinStrings(value: string | string[] | unknown) {
        return Array.isArray(value) ? value.join(' ') : value;
    }
}
